<!--视频组件-->
<template>
  <div class="video-box">
    <a>
    <video-player :options="playerOptions" :playsinline="true" class="vjs-custom-skin"
                  ref="videoPlayer" style="width:100%;height:100%"></video-player>
    </a>
    <div class="cmp-handle">
      <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-input__icon el-icon-more"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="handleCmp('delete', componentIndex)">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Video',
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',
          src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4', // 视频url地址
        }],
        poster: 'static/login/demo.jpg', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '暂时无法连接，请稍候', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({
            index,
          });
          break;
        default:
          break;
      }
    },
  },
  props: {
    componentIndex: {
      type: Number,
    },
  }
  ,
};
</script>

<style lang="scss">
  .video-box {
    width: 100%;
    height: 100%;

    .video-js.vjs-fluid {
      height: 100%;
    }

    .cmp-handle {
      position: absolute;
      top: 0;
      right: 0;

      .el-input__icon {
        color: white;
        line-height: 25px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/engineering/Video.vue